/* global gsap */
import { useRef, useState, useEffect } from 'react';
import FontFaceObserver from 'fontfaceobserver';
import { useOpacityScroll } from 'components/ProgramApp/animations';

const fontObserver = new FontFaceObserver('ABCGintoNordCondensed Bold', {
  weight: 400,
});

export default () => {
  const ref = useOpacityScroll();
  const animation = useRef<GsapTimeline | null>(null);
  const [font, setFont] = useState(false);
  const [image, setImage] = useState(false);

  function animate() {
    if (animation.current) {
      animation.current.play();
    }
  }

  useEffect(() => {
    const video = ref.current!.querySelector('.video');
    const heading = ref.current!.querySelectorAll('h1');

    animation.current = gsap.timeline({
      delay: 0.2,
      paused: true,
    });

    animation.current.fromTo(video, 1, { opacity: 0 }, { opacity: 1 }).fromTo(
      heading,
      1,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        stagger: 0.1,
        ease: 'power1.inOut',
      },
      '-=0.4'
    );

    return () => {
      animation.current!.pause();
      animation.current!.kill();
      animation.current = null;
    };
  }, []);

  useEffect(() => {
    let cancel = false;

    fontObserver.load(null, 3000).then(() => {
      if (!cancel) {
        setFont(true);
      }
    });

    return () => {
      cancel = true;
    };
  }, []);

  useEffect(() => {
    const image = ref.current!.querySelector('img')!;

    function onLoad() {
      setImage(true);
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onLoad);

    if (image.complete && image.naturalHeight !== 0) {
      setImage(true);
    }

    return () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onLoad);
    };
  }, []);

  useEffect(() => {
    if (font && image) {
      animate();
    }
  }, [font, image]);

  return [ref, animate];
};
